// Alternate, marketable name candidates explored during naming.
// Patchwire is the selected brand; the rest are the shortlist surfaced to the user.
export const BRAND_NAMES = [
  { name: "Patchwire", tagline: "Fixes delivered straight down the wire.", selected: true },
  { name: "Driftcatch", tagline: "Catch developers before they drift away." },
  { name: "Forewire", tagline: "See the friction before it's filed." },
  { name: "Resolvd", tagline: "Friction, already resolved." },
  { name: "Tracehook", tagline: "Hook into every stack trace." },
  { name: "Signalmend", tagline: "Mend the signal at the source." },
  { name: "Unsnarl", tagline: "Untangle adoption friction, automatically." },
  { name: "Mendstream", tagline: "A live stream of shipped fixes." },
  { name: "Quell", tagline: "Quell developer friction on contact." },
];
